import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'liebherr-table-container',
    templateUrl: 'table-container.component.html',
    styleUrls: ['./table-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableContainerComponent implements OnInit, AfterViewInit {
    @ViewChild('content') content?: ElementRef;

    overflowed = false;
    constructor(private cd: ChangeDetectorRef) {}

    ngOnInit() {}

    ngAfterViewInit() {
        if (this.content) {
            /**
             * detect if content container is overflowed
             * used for initial position of column toggle
             */
            setTimeout(() => {
                this.overflowed =
                    this.content?.nativeElement.scrollHeight > this.content?.nativeElement.clientHeight ||
                    this.content?.nativeElement.scrollWidth > this.content?.nativeElement.clientWidth;
                this.cd.markForCheck();
            }, 1000);
        }
    }
}
